var AggregationOperation = /*#__PURE__*/function (AggregationOperation) {
  AggregationOperation["COUNT"] = "Count";
  AggregationOperation["MIN"] = "Min";
  AggregationOperation["MAX"] = "Max";
  AggregationOperation["SUM"] = "Sum";
  AggregationOperation["ABS_SUM"] = "AbsSum";
  AggregationOperation["VAR"] = "Var";
  AggregationOperation["AVG"] = "Avg";
  AggregationOperation["MEDIAN"] = "Median";
  AggregationOperation["STD"] = "Std";
  AggregationOperation["FIRST"] = "First";
  AggregationOperation["LAST"] = "Last";
  AggregationOperation["SKIP"] = "Skip";
  AggregationOperation["COUNT_DISTINCT"] = "CountDistinct";
  AggregationOperation["DISTINCT"] = "Distinct";
  AggregationOperation["UNIQUE"] = "Unique";
  return AggregationOperation;
}(AggregationOperation || {});
export default AggregationOperation;
//# sourceMappingURL=AggregationOperation.js.map